export const OK = 200
export const NOT_AUTHORIZED = 401
export const NOT_FOUND = 404
export const INVALID_REQUEST = 400
export const CONFLICT = 409
export const SERVER_ERROR = 500
export const REQUEST_CANCELLED = 0